import { useEffect } from 'react';
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { FiMail } from 'react-icons/fi';

const InviteStep = ({ stepKey, updateStepData, getStepData }) => {
    const stepData = getStepData(stepKey);

    useEffect(() => {
        if (stepData) {
            updateStepData(stepKey, stepData);
        }
        // Mark as complete since this step is optional
        updateStepData(stepKey, { ...stepData, isComplete: true });
    }, []);

    return (
        <div className="flex flex-col space-y-8 items-center">
            <div className="flex flex-col items-center space-y-3">
                <h1 className="font-semibold text-3xl text-center">Invite your team</h1>
                <p className="text-center text-muted-foreground">Optional: Add team members to your organization</p>
            </div>
            <div className="w-full max-w-2xl mx-auto space-y-6">
                <div className="space-y-3">
                    <Label htmlFor="emails">Email addresses</Label>
                    <Textarea
                        id="emails"
                        value={stepData.teamEmails}
                        onChange={(e) => updateStepData(stepKey, { ...stepData, teamEmails: e.target.value })}
                        placeholder="Enter email addresses, separated by commas"
                        className="min-h-[100px]"
                    />
                    <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                        <FiMail className="w-4 h-4" />
                        <span>Team members will receive an invitation email to join your organization</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InviteStep; 